import { useState } from 'react';

type SetupOptionalStepsForm = {
  shipping_provider_id: string;
  shipping_provider_key: string;
};

const useSetupOptions = () => {
  const [setupOptionsForm, setSetupOptionsForm] =
    useState<SetupOptionalStepsForm>({
      shipping_provider_id: '',
      shipping_provider_key: '',
    });

  const [setupOptionalStepsForm, setSetupOptionalStepsForm] = useState({
    ignore_customs_details: false,
  });

  const [formErrors, setFormErrors] =
    useState<Partial<SetupOptionalStepsForm>>();

  const onValidate = () => {
    const errors: Partial<SetupOptionalStepsForm> = {};

    if (!setupOptionsForm.shipping_provider_id) {
      errors.shipping_provider_id = 'Provider ID is required';
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  return {
    setupOptionsForm,
    setupOptionalStepsForm,
    formErrors,
    setSetupOptionsForm,
    setSetupOptionalStepsForm,
    onValidate,
  };
};

export default useSetupOptions;
